// extracted by mini-css-extract-plugin
export var BorderButton = "Button-module--BorderButton--e4e6a";
export var Button = "Button-module--Button--78544";
export var ButtonMedium = "Button-module--ButtonMedium--1da22";
export var ButtonSmall = "Button-module--ButtonSmall--523f2";